import { render } from "./IconStraight.vue?vue&type=template&id=65c0f8a7"
import script from "./IconStraight.vue?vue&type=script&lang=js"
export * from "./IconStraight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__